<div class="fc-detail-form">
  <div class="fc-detail-form-header">
    <span class="material-icons fc-detail-form-icon">smart_toy</span>
    <h3 class="fc-detail-form-title">{{ agentForm.controls.id.value ? 'Edit Agent' : 'Add Agent' }}</h3>
  </div>

  <form [formGroup]="agentForm" (ngSubmit)="onSubmit()" class="fc-form-grid">
    <input formControlName="id" type="hidden" />

    <mat-form-field appearance="outline">
      <mat-label>Machine</mat-label>
      <mat-select formControlName="machineId" required>
        <mat-option *ngFor="let machine of machines" [value]="machine.id">{{ machine.serialNumber }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select formControlName="enabled" required>
        <mat-option [value]="true">Enabled</mat-option>
        <mat-option [value]="false">Disabled</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="fc-form-actions">
      <button type="reset" class="fc-btn fc-btn--ghost" (click)="clear()">Clear</button>
      <button type="submit" class="fc-btn fc-btn--primary" [disabled]="!agentForm.valid">Save</button>
    </div>
  </form>
</div>
